class collectionSort extends HTMLElement {

  constructor() {
    super();

    // detect if sorting is changed
    document.querySelector('#sort_by').addEventListener('change', function(e) {

      // get value of the selected select option
      var value = e.target.value;

      // update search parameters
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set("sort_by", value);
      window.location.search = searchParams.toString();

    });

  }
}

if (!customElements.get('collection-sort')) {
  customElements.define('collection-sort', collectionSort);
}